module.exports = angular.module('cartographer.common.debounce', [])

_ = require 'underscore'

# Adapted from https://stackoverflow.com/questions/29771011/angularjs-watch-with-debounce
module.exports.factory 'crtDebounce', $DI ($timeout, $q) ->
  _debounce = (wait, immediate = false, func) ->
    timeout = null

    deferred = $q.defer()

    return ->
      context = this
      args     = arguments

      later = ->
        timeout = null
        if !immediate
          deferred.resolve(func.apply(context, args))
          deferred = $q.defer()

      callNow = immediate && !timeout

      if timeout
        $timeout.cancel(timeout)

      timeout = $timeout(later, wait)

      if callNow
        deferred.resolve(func.apply(context,args))
        deferred = $q.defer()

      return deferred.promise

  debounce = (wait, func) ->
    _debounce(wait, false, func)

  debounceImmediate = (wait, func) ->
    _debounce(wait, true, func)

  return {
    debounce
    debounceImmediate
  }